import {
  getRestCnt,
  getHoliCnt,
  getHour,
  checkVacationDet,
  postVacationDet,
  getOtWorkSysInfo,
  getOtWorkStatus,
  getOtWorkHour,
  postOtWorkDet,
  checkOtWorkDet,
  getScheduleStatus,
  getWorkOrgTimeList,
  checkScheduleDet,
  postScheduleDet,
  getRewardHoliCnt,
  getRewardList,
  checkRewardDet,
  postRewardDet,
  getAttendStatus,
  checkAttendDet,
  postAttendDet,
  checkCancelVacation,
  postCancelVacation,
  checkCancelReward,
  postCancelReward,
} from '@/api/application';

import {
  vaccinationSave,
  edusAppSave,
  leaAbsAppSave,
  holReplaceSave,
  holReplaceCancelSave,
  saveCertiAppDet,
  workScheduleTimeSave,
  vacationSave,
  cancelSaveVacation,
} from '@/api/workStatus';
import { applovalCommonSave } from '@/api/approvalCommon';

import { checkAnnualPlanDet } from '@/api/annualPlan';

import applicationGetters from './applicationGetters';
import applicationMutations from './applicationMutations';

import routerNames from '@/const/routerConstants';
import applCode from '@/const/applCodeConstants';
import dayjs from 'dayjs';
import { deleteApplication } from '@/api/application';

/* 신청 */
const application = {
  state: {
    // ======================= COMMON =========================
    appMenu: {}, // 선택한 신청서 메뉴 정보
    reason: '',
    applYmd: '',
    reqSHm: '',
    reqEHm: '',
    requestHour: '',
    sYmd: '',
    eYmd: '',
    sYmdWeek: '',
    eYmdWeek: '',
    holDay: '', // 전체일수
    closeDay: '', // 적용일수
    workYmd: '',
    workWeek: '',

    // fileList: [],
    reasonFlag: '',
    // ======================= ATTEND =======================
    attendParam: {}, // 출퇴근신청 기본 파라미터
    bfShm: '',
    bfEhm: '',
    afShm: '',
    afEhm: '',
    // ======================= REWARD =======================
    rewardParam: {}, // 보상휴가 기본 파라미터
    rewardList: [],
    useRewardList: [], // 사용한 보상휴가 목록
    reqTime: 0,
    // ======================= SCHEDULE =======================
    scheduleParam: {}, // 근무스케줄 기본 파라미터
    searchWorkTypeCd: '',
    workOrgCd: '', // 근무유형 코드
    intervalCd: '', // 근무주기
    stdYmd: '',
    dayGubunCd: '',
    scheduleTimeCd: '', // 변경한 근무시간코드

    workOrgNm: '',
    workOrgTimeList: [],
    scheduleTimeNm: '',
    // ======================= OTWORK =========================
    otworkParam: {}, // 연장근무 기본 파라미터
    reqTimeCd: '', // 휴일근무 보상구분 (A:수당, B:대체휴가, C:보상시간)
    restHour: '',
    inoutYn: 'Y',
    alterYmd: '',
    alterWeek: '',
    alterGntCd: '',

    altvacApplStatus: 'N', // 대체휴가 자동신청 여부 및 신청상태 (N / 11~99)
    alterGntNm: '',
    holYn: 'N', // 휴일여부
    applGubun: '', // A: 사후, B: 사전
    inOut: '|',
    // ======================= VACATION =======================
    vacationParam: {}, // 근태 기본 파라미터
    alterVacation: {}, // 선택한 휴일 근무일 정보
    gntCd: {}, // 근태명
    gntGubunCd: '',
    halfYn: 'N', // 반차 여부
    restCnt: '', // 잔여일수
    applYmdWeek: '',
    holWorkYmd: '', // 대체휴일
    holWorkYmdCombo: '',
    // ======================= CANCEL =======================
    searchBfApplSeq: '', // 기존 신청서 seq
    // ======================= PLAN =======================
    planParam: {}, // 연차계획 파라미터
  },
  getters: applicationGetters,
  mutations: applicationMutations,
  actions: {
    // ======================= MENU =======================
    /* 메뉴 선택시 기본 데이터 셋팅 및 다음페이지 리턴 */
    async FETCH_MENU_ACTION({ rootState, dispatch, commit }, params) {
      // 0. 초기화
      commit('RESET_ELA_STATE');
      commit('RESET_APPLICATION_STATE');

      try {
        // console.log('applCd ::: ' + params.applCd);
        const applCd = params.applCd;
        const gntGubunCd = params.gntGubunCd;
        const todayYMD = dayjs().format('YYYYMMDD');
        const ssnSabun = rootState.userData.ssnSabun;

        await dispatch('FETCH_ELA_APPL_INFO', {
          searchApplCd: applCd,
          adminYn: 'N',
          authPg: 'A',
          searchApplSeq: null,
          searchApplSabun: ssnSabun,
          searchApplInSabun: ssnSabun,
          searchApplStatusCd: '21', // 신청
          searchApplYmd: todayYMD,
        });

        commit('SET_APP_MENU', params);
        let routerName = routerNames.StartDate;
        if (applCd === applCode.Vacations) {
          // 근태
          routerName = routerNames.VacationMyWorkHoliday; // 휴가신청 선택 메뉴

        } else if (applCd === applCode.OtWork) {
          commit('SPINNER/ON_APP_SPINNER', {}, { root: true }); // 상위나 형제 actions 접근시

          // 연장근무
          // 휴일근무 보상기준 조회
          const reqTimeCd = await dispatch('FETCH_OT_WORK_SYS_INFO');
          // 대체휴가 코드 조회
          if (reqTimeCd === 'B') {
            await dispatch(
              'CODE/FETCH_GNT_CD',
              {
                cmd: 'alterGntCdApp',
              },
              { root: true }, // 상위나 형제 actions 접근시
            );
          }
        } else if (applCd === applCode.Schedule) {
          // 근무스케쥴
        } else if (applCd === applCode.Reward) {
          // 보상휴가
          commit('SET_GNT_GUBUN_CD', '10'); // 임시
          commit('SET_S_YMD', todayYMD);
          commit('SET_E_YMD', todayYMD);

          routerName = routerNames.GntTypeMenu;
        } else if (applCd === applCode.Attend) {
          // 출퇴근변경신청
        } else if (
          applCd === applCode.CancelVacation ||
          applCd === applCode.CancelReward
        ) {
          // 근태취소, 보상휴가취소
          routerName = routerNames.CancelMenu;
        } else if (applCd === applCode.EdusApp) {
          //학자금신청
          routerName = routerNames.EdusApp;
        } else if (applCd === applCode.Vaccination) {
          //독감예방접종신청
          routerName = routerNames.Vaccination;
        } else if (
          applCd === applCode.LeaAbsParental ||
          applCd === applCode.LeaAbsFamily
        ) {
          //휴/복직신청 (육아휴직, 가족돌봄휴직)
          routerName = routerNames.LeaAbsAppStep2;
        } else if (
          applCd === applCode.LeaAbsInfertility ||
          applCd === applCode.LeaAbsSick ||
          applCd === applCode.LeaAbsCasualty ||
          applCd === applCode.LeaAbsNew ||
          applCd === applCode.eaAbsExtension
        ) {
          //휴/복직신청
          routerName = routerNames.StartDateAppl;
        } else if (applCd === applCode.LeaAbsApplication) {
          //휴/복직신청 (복직신청)LeaAbsExtension
          routerName = routerNames.DateAppl;
        } else if (
          applCd === applCode.LeaAbsExtension ||
          applCd === applCode.LeaAbsAdd
        ) {
          //휴/복직신청 (육아휴직연장)
          commit('SET_APPL_CD', applCd);
          routerName = routerNames.LeaAbsBoxView;
        } else if (applCd === applCode.HolReplaceApp) {
          //휴일근무사전대체신청
          routerName = routerNames.HolReplaceApp;
        } else if (applCd === applCode.HolReplaceBoxView) {
          //휴일근무사전대체취소신청리스트
          routerName = routerNames.HolReplaceBoxView;
        } else if (applCd === applCode.ReCertTenureAppView) {
          //재직증명(한글)
          routerName = routerNames.ReCertTenureAppView;
        } else if (applCd === applCode.ReCertTenureEngAppView) {
          //재직증명(영문)
          routerName = routerNames.ReCertTenureEngAppView;
        } else if (
          applCd === applCode.ReCertTenureTax1AppView ||
          applCd === applCode.ReCertTenureTax2AppView
        ) {
          //원천징수영수증, 원천징수부
          routerName = routerNames.ReCertTenureTaxAppView;
        } else if (applCd === applCode.ReCertLeaveAppView) {
          //원천징수영수증, 원천징수부
          routerName = routerNames.ReCertLeaveAppView;
        } else if (applCd === applCode.ReCertGabTaxView) {
          //원천징수영수증, 원천징수부
          routerName = routerNames.ReCertGabTaxView;
        } else if (applCd === applCode.WorkScheduleTime1) {
          //원천징수영수증, 원천징수부
          routerName = routerNames.WorkScheduleTime1;
        } else if(applCd === applCode.VacationsCancel) {
          //
        } else {
          alert('준비중입니다.');
          return false;
        }

        commit('SPINNER/OFF_APP_SPINNER', {}, { root: true }); // 상위나 형제 actions 접근시
        return routerName;
      } catch (error) {
        console.log(error);
      }
    },

    // ======================= PLAN =======================

    // 연차계획작성 - 확인
    async VALIDATE_PLAN_DET({ getters, commit, rootState }) {
      commit('SET_PLAN_PARAM');
      const planParam = getters.GET_PLAN_PARAM;
      planParam['searchSabun'] = rootState.userData.ssnSabun;

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkAnnualPlanDet(planParam);
      const checkResponseMsg = checkResponse.data.message;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        commit('SET_APPL_YMD', '');
        commit('SET_APPL_YMD_WEEK', '');
      } else if (Number(checkResponse.data.data.dupCnt) > 0) {
        alert('해당일에 기 신청건이 존재합니다.');
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        return;
      } else {
        commit('SET_HALF_YN');
        commit('SET_CLOSE_DAY', checkResponse.data.data);
      }

      return isMsgOK;
    },

    // ======================= VACATION =======================
    // 잔여일수 조회
    async FETCH_REST_CNT({ state, getters, commit }) {
      commit('SET_VACATION_PARAM');
      const response = await getRestCnt(getters.GET_VACATION_PARAM);
      state.restCnt = response.data.data.restCnt;
    },

    // 전체일수, 휴일일수 조회
    async FETCH_HOLI_CNT({ getters, commit }) {
      commit('SET_VACATION_PARAM');
      const response = await getHoliCnt(getters.GET_VACATION_PARAM);
      commit('SET_CLOSE_DAY', response.data.data);
    },

    // 적용시간 조회
    async FETCH_HOUR({ getters, commit }) {
      commit('SET_VACATION_PARAM');
      const response = await getHour(getters.GET_VACATION_PARAM);
      commit('SET_REQUEST_HOUR', response.data.data.restTime);
    },

    // 근태 - 확인
    async VALIDATE_VACATION_DET({ getters, commit }) {
      commit('SET_VACATION_PARAM');
      const vacationParam = getters.GET_VACATION_PARAM;

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkVacationDet(vacationParam);
      const checkResponseMsg = checkResponse.data.data.msg;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        commit('SET_APPL_YMD', '');
        commit('SET_APPL_YMD_WEEK', '');
      }

      return isMsgOK;
    },

    // 근태 - 저장
    async SAVE_VACATION_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch(
        'BEFORE_SAVE',
        'VALIDATE_VACATION_DET',
      );
      if (!validResult) return returnValue;

      // 신청 저장
      const vacationParam = getters.GET_VACATION_PARAM;
      const saveResponse = await postVacationDet(vacationParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= OTWORK =======================
    // 연장근무 - 휴일근무 보상구분 조회
    async FETCH_OT_WORK_SYS_INFO({ commit }) {
      commit('SET_OTWORK_PARAM');
      const response = await getOtWorkSysInfo();
      const data = response.data.data;

      commit('SET_REQ_TIME_CD', data.reqHolWork);
      commit('SET_ALTVAC_APPL_STATUS', data.altvacApplStatus);

      return response.data.data.reqHolWork;
    },

    // 연장근무 - 확인
    async VALIDATE_OT_WORK_STATUS({ getters, commit, dispatch }) {
      let returnData = false;
      commit('SET_OTWORK_PARAM');

      const response = await getOtWorkStatus(getters.GET_OTWORK_PARAM);
      const data = response.data.data;

      if (data === undefined) {
        alert('해당 일에 근무스케줄이 없습니다. 담당자에게 문의하세요.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }
      if (data.statusCd !== 'AA') {
        alert('해당 일에 재직상태가 아닙니다.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }
      if (data.beginShm === null || data.beginShm === '') {
        alert('해당 일에 근무스케줄이 없습니다. 담당자에게 문의하세요.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }

      commit('SET_HOL_YN', data.holYn); // 휴일 여부
      commit('SET_APPL_GUBUN', data.applGubun); // 보상기준
      commit('SET_IN_OUT', data); // 출퇴근시간

      // 적용시간 조회
      if (getters.GET_REQ_S_E_HM !== '') {
        dispatch('FETCH_OT_WORK_HOUR');
      }

      return !returnData;
    },

    // 연장근무 - 시간 조회
    async FETCH_OT_WORK_HOUR({ getters, commit }) {
      commit('SET_OTWORK_PARAM');
      const response = await getOtWorkHour(getters.GET_OTWORK_PARAM);
      const data = response.data.data;
      commit('SET_REST_HOUR', data.restHour);
      commit('SET_REQUEST_HOUR', data.hour);
    },

    // 연장근무 - 확인
    async VALIDATE_OT_WORK_DET({ getters, commit }) {
      commit('SET_OTWORK_PARAM');

      const response = await checkOtWorkDet(getters.GET_OTWORK_PARAM);
      const checkResponseMsg = response.data.data.msg;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        // commit('SET_WORK_YMD', '');
        // commit('SET_WORK_WEEK', '');
        // commit('SET_REQUEST_HOUR', '');
      }

      return isMsgOK;
    },

    // 연장근무 - 저장
    async SAVE_OT_WORK_DET({ getters, dispatch }) {
      let returnValue = false;

      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_OT_WORK_DET');
      if (!validResult) return returnValue;

      // 신청 저장
      const vacationParam = getters.GET_OTWORK_PARAM;
      const saveResponse = await postOtWorkDet(vacationParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= SCHEDULE =======================
    // 근무스케줄 - 상태확인 및 스케줄 정보 조회
    async VALIDATE_SCHEDULE_STATUS({ getters, commit }) {
      let returnData = false;
      commit('SET_SCHEDULE_PARAM');

      const response = await getScheduleStatus(getters.GET_SCHEDULE_PARAM);
      const data = response.data.data;

      if (data.statusCd !== 'AA') {
        alert('해당 일에 재직상태가 아닙니다.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }

      commit('SET_SEARCH_WORK_TYPE_CD', data.workTypeCd);
      commit('SET_WORK_ORG_CD', data.workOrgCd);
      commit('SET_INTERVAL_CD', data.workCycleCd);
      commit('SET_WORK_ORG_NM', data.workOrgNm);
      commit('SET_DAY_GUBUN_CD', '1');

      return !returnData;
    },

    // 근무스케줄 - 기 신청건 체크
    async VALIDATE_SCHEDULE_DET({ getters, commit }) {
      commit('SET_SCHEDULE_PARAM');

      const response = await checkScheduleDet(getters.GET_SCHEDULE_PARAM);
      const checkCnt = response.data.data.cnt;
      const isOk = checkCnt === 0;
      if (!isOk) {
        alert(
          '해당 근무일에 신청한 신청건이 결재처리 중으로 중복 신청할 수 없습니다.',
        );
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
      }

      return isOk;
    },

    // 근무스케줄 - 근무유형 근무시간 조회
    async FETCH_WORK_ORG_TIME_LIST({ state, commit }) {
      const response = await getWorkOrgTimeList({
        searchWorkTypeCd: state.searchWorkTypeCd,
      });
      commit('SET_WORK_ORG_TIME_LIST', response.data.data);
    },

    // 근무스케줄 - 저장
    async SAVE_SCHEDULE_DET({ getters, dispatch }) {
      let returnValue = false;

      const validResult = await dispatch(
        'BEFORE_SAVE',
        'VALIDATE_SCHEDULE_DET',
      );
      if (!validResult) return returnValue;

      // 신청 저장
      const saveResponse = await postScheduleDet(getters.GET_SCHEDULE_PARAM);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },
    // ======================= REWARD =======================

    // 전체일수, 휴일일수 조회
    async FETCH_REWARD_HOLI_CNT({ getters, commit }) {
      commit('SET_REWARD_PARAM');
      const response = await getRewardHoliCnt(getters.GET_REWARD_PARAM);
      const resData = response.data.data;
      commit('SET_CLOSE_DAY', resData);
      const holDay = Number(resData.holDay);
      commit(
        'SET_REQUEST_HOUR',
        (holDay - resData.holidayCnt) * resData.stdApplyHour,
      );
    },

    // 보상휴가 - 보상 목록 조회
    async FETCH_REWARD_LIST({ getters, commit }) {
      commit('SET_REWARD_PARAM');
      const response = await getRewardList(getters.GET_REWARD_PARAM);
      commit('SET_REWARD_LIST', response.data.data);
    },

    // 보상휴가 - 확인
    async VALIDATE_REWARD_DET({ getters, commit }) {
      commit('SET_REWARD_PARAM');

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkRewardDet(getters.GET_REWARD_PARAM);
      const checkResponseMsg = checkResponse.data.data.msg;
      const isMsgOK = checkResponseMsg == 'OK';
      if (!isMsgOK) {
        alert(checkResponseMsg);
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
      }

      return isMsgOK;
    },

    // 보상휴가 - 저장
    async SAVE_REWARD_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_REWARD_DET');
      if (!validResult) return returnValue;

      const rewardSaveParam = {
        ...getters.GET_REWARD_PARAM,
        mergeRows: getters.GET_USE_REWARD_LIST,
      };

      // 신청 저장
      const saveResponse = await postRewardDet(rewardSaveParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= ATTEND =======================
    // 출퇴근변경신청 - 상태확인 및 스케줄 정보 조회
    async VALIDATE_ATTEND_STATUS({ getters, commit }) {
      // console.log('VALIDATE_ATTEND_STATUS');
      let returnData = false;
      commit('SET_ATTEND_PARAM');
      // console.log('VALIDATE_ATTEND_STATUS2');

      const response = await getAttendStatus(getters.GET_ATTEND_PARAM);
      const data = response.data.data;
      // console.log('VALIDATE_ATTEND_STATUS3');

      if (data.statusCd !== 'AA') {
        alert('해당 일에 재직상태가 아닙니다.');
        commit('SET_WORK_YMD', '');
        return returnData;
      }

      if (data.inOut !== null && data.inOut !== '|') {
        const inOut = data.inOut.split('|');
        commit('SET_BEFORE_START_HM', inOut[0]);
        commit('SET_BEFORE_END_HM', inOut[1]);
      } else {
        commit('SET_BEFORE_START_HM', '');
        commit('SET_BEFORE_END_HM', '');
      }

      return !returnData;
    },

    // 출퇴근변경신청 - 확인
    async VALIDATE_ATTEND_DET({ getters, commit }) {
      let returnData = false;
      commit('SET_ATTEND_PARAM');

      //재직상태 및 신청대상자 체크
      const checkResponse = await checkAttendDet(getters.GET_ATTEND_PARAM);
      const checkResponseMsg = checkResponse.data.data.chkMsg;
      const checkCnt = checkResponse.data.data.cnt;
      const isOk = checkCnt === 0;

      if (!isOk) {
        alert(
          '해당 근무일에 신청한 신청건이 결재처리 중으로 중복 신청할 수 없습니다.',
        );
        commit('SET_S_YMD', '');
        commit('SET_E_YMD', '');
        return returnData;
      }

      if (checkResponseMsg !== null && checkResponseMsg !== '') {
        alert(`신청 가능한 근무일은 ${checkResponseMsg}입니다.`);
        return returnData;
      }

      return !returnData;
    },

    // 출퇴근변경신청 - 저장
    async SAVE_ATTEND_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_ATTEND_DET');
      if (!validResult) return returnValue;

      const attendSaveParam = {
        ...getters.GET_ATTEND_PARAM,
      };

      // 신청 저장
      const saveResponse = await postAttendDet(attendSaveParam);
      if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // ======================= CANCEL =======================
    // 취소신청 - 확인
    async VALIDATE_CANCEL_DET({ getters }) {
      const cancelParam = getters.GET_CANCEL_PARAM;
      let checkResponse = {};
      if (cancelParam.searchApplCd === '23') {
        checkResponse = await checkCancelVacation(cancelParam);
      } else if (cancelParam.searchApplCd === '43') {
        checkResponse = await checkCancelReward(cancelParam);
      }

      //재직상태 및 신청대상자 체크
      const checkCnt = checkResponse.data.data.cnt;
      const isOk = checkCnt === 0;
      if (!isOk) {
        alert(
          '해당 근무일에 신청한 신청건이 결재처리 중으로 중복 신청할 수 없습니다.',
        );
      }

      return isOk;
    },

    // 근태 - 저장
    async SAVE_CANCEL_DET({ getters, dispatch }) {
      let returnValue = false;

      // 신청 확인
      const validResult = await dispatch('BEFORE_SAVE', 'VALIDATE_CANCEL_DET');
      if (!validResult) return returnValue;

      // 신청 저장
      const cancelParam = getters.GET_CANCEL_PARAM;
      let saveResponse = {};
      if (cancelParam.searchApplCd === '23') {
        saveResponse = await postCancelVacation(cancelParam);
      } else if (cancelParam.searchApplCd === '43') {
        saveResponse = await postCancelReward(cancelParam);
      }

      if (
        saveResponse.errorMessage != '' &&
        saveResponse.errorMessage != undefined
      ) {
        alert(saveResponse.errorMessage);
        return returnValue;
      } else if (saveResponse.data < 1) {
        alert(saveResponse.message);
        return returnValue;
      }

      return !returnValue;
    },

    // 독감예방접종 - 저장
    async SAVE_VACCINATION_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_VACCINATION_PARAM;
      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중

      let resultCnt = await vaccinationSave(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
      }
      }

      return !returnValue;
    },

    // 학자금신청 - 저장
    async SAVE_EDUSAPP_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_EDUSAPP_PARAM;
      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중

      // console.log('parmas :::: ' + JSON.stringify(params));

      let resultCnt = await edusAppSave(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
        }
      }

      return !returnValue;
    },

    // 휴/복직신청 - 저장
    async SAVE_LEAABS_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_LEAABS_PARAM;
      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중
      params.vacationAtOnceTimKey = param.vacationAtOnceTimKey;

      // console.log('SAVE_LEAABS_DET parmas :::: ' + JSON.stringify(params));

      let resultCnt = await leaAbsAppSave(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
      }
      }

      return !returnValue;
    },

    // 휴일근무사전대체신청 - 저장
    async SAVE_HOL_REPLACE_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_HOL_REPLACE_PARAM;
      // console.log('params ::: ' + JSON.stringify(params));
      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중

      let resultCnt = await holReplaceSave(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
      }
      }

      return !returnValue;
    },

    // 휴일근무사전대체취소신청 - 저장
    async SAVE_HOL_REPLACE_CANCEL_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_HOL_REPLACE_CANCEL_PARAM;

      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중
      params.searchApplCd = '311';

      let resultCnt = await holReplaceCancelSave(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
      }
      }

      return !returnValue;
    },

    // 재직증명 - 저장
    async SAVE_RECERT_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_RECERT_PARAM;

      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중

      let resultCnt = await saveCertiAppDet(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
      }
      }

      return !returnValue;
    },

    // 시차출근 - 저장
    async SET_WORK_SCHEDULE_TIME_DET({ getters }, param) {

      let returnValue = false;
      // 신청 저장
      const params = getters.GET_WORK_SCHEDULE_TIME_PARAM;

      // eslint-disable-next-line no-unreachable
      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중

      // console.log('parmas :::: ' + JSON.stringify(params));

      let resultCnt = await workScheduleTimeSave(params);

      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
          alert('신청이 실패하였습니다\n관리자에게 문의하세요');
          const deleteRows = [];

          const applSeq = params.searchApplSeq;

          deleteRows.push({ applSeq });

          await deleteApplication(params.searchApplCd, {
            deleteRows,
          });
      }
      }

      return !returnValue;
    },

    // 휴가신청 - 저장
    async SAVE_VACATIONS_DET({ getters }, param) {
      let returnValue = false;
      // 신청 저장
      const params = getters.GET_VACATIONS_PARAM;
      params.appls = param.appls;
      params.inusers = param.inusers;
      params.searchApplSabun = param.searchApplSabun;
      params.searchApplYmd = dayjs().format('YYYYMMDD');
      params.applStatusCd = '31'; //수신처리중

      let resultCnt;

      // eslint-disable-next-line no-unreachable
      if (params.isCancelVacation) {
        resultCnt = await cancelSaveVacation(params);
      } else {
        resultCnt = await vacationSave(params);
      }



      if (resultCnt.data.data > 0) {
        resultCnt = await applovalCommonSave(params);

        if (resultCnt.data.data > 0) {
          alert('신청 되었습니다');
          let response = { data: { data: {} } };
          response.data.message = 'OK';
          response.data.data.Code = '1';
          return response;
        } else {
            alert('신청이 실패하였습니다\n관리자에게 문의하세요');
            const deleteRows = [];

            const applSeq = params.searchApplSeq;

            deleteRows.push({ applSeq });

            await deleteApplication(params.searchApplCd, {
              deleteRows,
            });
        }
      }

      return !returnValue;
    },


    async BEFORE_SAVE({ getters, dispatch }, validateApiName) {
      let returnValue = false;
      // 본인결재 체크
      if (
        getters.GET_UI_INFO.pathSelfCloseYn === 'N' &&
        getters.GET_APPL_USER_LIST.length < 2
      ) {
        alert(
          '결재선이 본인만 지정되었습니다. 결재자를 추가로 지정하여 신청해 주십시요.',
        );
        return returnValue;
      }

      //재직상태 및 신청대상자 체크
      const checkResponse = await dispatch(validateApiName);
      if (!checkResponse) return returnValue;

      return !returnValue;
    },

    async SET_VACCINATION_PARAMS({ commit }, params) {
      commit('SET_VACCINATION_PARAM', params);
    },

    async SET_EDUSAPP_PARAMS({ commit }, params) {
      commit('SET_EDUSAPP_PARAM', params);
    },

    async SET_LEAABS_PARAMS({ commit }, params) {
      commit('SET_LEAABS_PARAM', params);
    },

    async SET_HOL_REPLACE_PARAMS({ commit }, params) {
      commit('SET_HOL_REPLACE_PARAM', params);
    },
    async SET_HOL_REPLACE_CANCEL_PARAMS({ commit }, params) {
      commit('SET_HOL_REPLACE_CANCEL_PARAM', params);
    },

    async SET_RECERT_PARAMS({ commit }, params) {
      commit('SET_RECERT_PARAM', params);
    },

    async SET_WORK_SCHEDULE_TIME_PARAMS({ commit }, params) {
      commit('SET_WORK_SCHEDULE_TIME_PARAM', params);
    },

    async SET_VACATION_PARAMS({ commit }, params) {
      commit('SET_VACATIONS_PARAM', params);
    },

  },
};

export default application;
